// extracted by mini-css-extract-plugin
export default {"muted":"AppointmentFormModal_muted__psFZW","actions":"AppointmentFormModal_actions__U0NSX"};